import React, {useState, useEffect} from "react";
import styled  from "styled-components";
import { useTranslation } from "react-i18next";

const ContactButton = styled.a`
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: #6A8CAF;
  color: white;
  text-decoration: none;
  padding: 0.85rem 1.25rem;
  border-radius: 9999px;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};


  /* Only show on mobile */
  @media (min-width: 768px) {
    display: none;
  }
`;

const Nav = () => {
  const { t, i18n } = useTranslation();
  
    const [visible, setVisible] = useState(true);
    useEffect(() => {
    const contactSection = document.querySelector("#contact");

    if (!contactSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // If the contact section is visible, hide the button
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0.2 } // adjust: 0.2 means "20% visible"
    );

    observer.observe(contactSection);

    return () => observer.disconnect();
  }, []);

return <ContactButton href="#contact" visible={visible}>{t("getintouchMobile")}</ContactButton>;
};

export default Nav;
